import Vue from 'vue';

// Canal só para coordenar os menus de ação por linha (RowActionMenu.vue): garante que
// abrir um feche qualquer outro já aberto em qualquer grid da tela (ex.: o grid de veículos
// e a subtabela de despesas em Veiculos.vue são duas árvores de componentes independentes,
// sem um ancestral comum que já guarde esse estado).
export default new Vue();
